import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ReplaySubject, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class PermissionsService {
    private userPermissions: string[] = [];
    private userPermissions$: ReplaySubject<any> = new ReplaySubject<any>();

    private authBasePath = environment.interop.authCore.basePath;
    private getUserPermissionsUrl =
        this.authBasePath +
        environment.interop.authCore.platform.getUserPermissionsAuthLib;

    constructor(private http: HttpClient) { }

    private fetchUserPermissions(clientId: number, moduleId: number) {
        return this.http
            .get(this.getUserPermissionsUrl + clientId + '/' + moduleId)
            .pipe(
                // tap((data) => console.log(data)),
                map(
                    (response: any) => {
                        if (response.data.length === 0) { return [] };
                        return (Object.values(response.data)[0] as any).permissions
                    }
                )
            );
    }

    storeUserPermissions() {
        return this.fetchUserPermissions(
            environment.interop.clientId,
            environment.interop.moduleId
        ).subscribe({
            next: (data: any) => {
                this.userPermissions = data;
                this.userPermissions$.next(true);
            },
            error: (err: any) => {
                console.log(err);
            },
        });
    }

    getUserPermissions() {
        return this.userPermissions;
    }

    getUserPermissions$() {
        return this.userPermissions$;
    }

    hasPermission(targetPermission: string): boolean {
        const hasPerm = this.userPermissions.some((permission) =>
            permission.includes(targetPermission)
        );
        return hasPerm;
    }
}
